import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';
import momentDurationFormatSetup from 'moment-duration-format';
import ToggleSwitch from '@trendmicro/react-toggle-switch';

import RangeSelect from './../../FormComponents/RangeSelect';

momentDurationFormatSetup(moment);

export default function BusinessProfile(props) {
  const { errors, onChange, setRef, disabled , preferences} = props;
  const { isSchemaFetched , schema } = preferences;
  const details = Object.assign(
    {
      business_working_hours: {},
      business_open_days: {},
    },
    props.details,
  );

  const DaysOfWeek = [
    {
      label: 'Monday',
      code: 'MONDAY',
    },
    {
      label: 'Tuesday',
      code: 'TUESDAY',
    },
    {
      label: 'Wednesday',
      code: 'WEDNESDAY',
    },
    {
      label: 'Thursday',
      code: 'THURSDAY',
    },
    {
      label: 'Friday',
      code: 'FRIDAY',
    },
    {
      label: 'Saturday',
      code: 'SATURDAY',
    },
    {
      label: 'Sunday',
      code: 'SUNDAY',
    },
  ];

  const renderWorkingHours = (item, index) => {
    const onWorkingHoursChange = (range) => {
      let start;
      if (range[0] > 0 && range[0] !== 86400) {
        start = moment.duration(range[0], 's').format('HH:mm:ss');
      } else if (range[0] === 86400) {
        start = '23:59:59';
      } else {
        start = '00:00:00';
      }

      let end;
      if (range[1] > 0 && range[1] !== 86400) {
        end = moment.duration(range[1], 's').format('HH:mm:ss');
      } else if (range[1] === 86400) {
        end = '23:59:59';
      } else {
        end = '00:00:00';
      }

      onChange({
        target: {
          name: 'business_working_hours',
          value: Object.assign({}, details.business_working_hours, {
            [item.code]: {
              start,
              end,
            },
          }),
        },
      });
    };

    const onOpenDaysChange = () => {
      onChange({
        target: {
          name: 'business_open_days',
          value: Object.assign({}, details.business_open_days, {
            [item.code]: !details.business_open_days[item.code],
          }),
        },
      });
    };

    const { start, end } = details.business_working_hours[item.code] || {};
    const newValue = [];

    if (start && end) {
      newValue[0] = moment.duration(start, 'HH:mm:ss').asSeconds();
      newValue[1] = moment.duration(end, 'HH:mm:ss').asSeconds();
    }

    const defaultValue = [28800, 68400];

    return (
      <div className="multi-check__item multi-check__item--full" key={index}>
        <ToggleSwitch
          checked={!!details.business_open_days[item.code]}
          name={item.code}
          onChange={onOpenDaysChange}
          disabled={disabled}
        />
        <label htmlFor={item.code}>{item.label}</label>
        <div className="multi-check__item__slider" id={item.code}>
          <RangeSelect
            min={0}
            max={86400}
            defaultValue={defaultValue}
            value={newValue}
            step={1800}
            allowCross={false}
            marks={{ 0: '12:00am', 86400: '11:59pm' }}
            dots
            dotStyle={{
              width: '1px',
              border: '1px solid #e9e9e9',
              borderRadius: '0',
              bottom: '-8px',
              height: '4px',
              marginLeft: '-1px',
            }}
            tipFormatter={(value) => {
              let duration = moment.duration(value, 's').format('HH:mm');
              if (duration === '00') {
                duration = '00:00';
              } else if (duration === '30') {
                duration = '00:30';
              } else if (duration === '24:00') {
                duration = '23:59';
              }

              return moment(duration, 'HH:mm').format('hh:mma');
            }}
            disabled={!details.business_open_days[item.code] || disabled}
            onAfterChange={onWorkingHoursChange}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="business">
      {/* <div className="business__row">
        <p className="business__row__label">Link to your website</p>
        <div className="business__row__input">
          <input
            type="text"
            name="website_link"
            value={details.website_link}
            onChange={onChange}
            className={classnames({ 'has-error': errors.website_link })}
            disabled={disabled}
            ref={setRef}
          />
          <span className="message--small message--error">
            {errors.website_link && errors.website_link.message}
          </span>
        </div>
      </div> */}

      {/* <div className="preferences--separator" /> */}

      {/* <div className="business__row">
        <p className="business__row__label">Link to your FAQs</p>
        <div className="business__row__input">
          <input
            type="text"
            name="faqs_link"
            value={details.faqs_link}
            onChange={onChange}
            className={classnames({ 'has-error': errors.faqs_link })}
            disabled={disabled}
            ref={setRef}
          />
          <span className="message--small message--error">
            {errors.faqs_link && errors.faqs_link.message}
          </span>
        </div>
      </div> */}
      {schema?.business_open_days && 
      <div className="business__row business__row--column">
        <p className="business__row__label head-label">What are your working hours?</p>
        <div className="bookings__row__input multi-check">{DaysOfWeek.map(renderWorkingHours)}</div>
      </div>
      }
    </div>
  );
}

BusinessProfile.defaultProps = {
  onChange: () => {},
  setRef: () => {},
  details: {},
  errors: {},
  disabled: false,
};

BusinessProfile.propTypes = {
  onChange: PropTypes.func,
  setRef: PropTypes.func,
  details: PropTypes.shape(),
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
};
